<template>
	<inertia-head title="Transactions Pending" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Transactions Pending</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Pending Transactions</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded shadow mb-1">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row mb-2">
						<div class="col-md-3">
							<div class="form-check h5 mb-3">
								<input
									v-model="form.otc"
									class="form-check-input"
									type="checkbox"
									id="otc"
									true-value="1"
									false-value="0"
									name="otc"
								/>
								<label class="form-check-label ms-1">
									Over The Counter
								</label>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-check h5 mb-3">
								<input
									v-model="form.bank_transfer"
									class="form-check-input"
									type="checkbox"
									id="bank_transfer"
									true-value="1"
									false-value="0"
									name="bank_transfer"
								/>
								<label class="form-check-label ms-1">
									Bank Transfer
								</label>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<div class="form-group mb-4">
								<flat-pickr
									v-model="form.startDate"
									id="startDate"
									class="form-select"
									placeholder="Select start date"
								/>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group mb-4">
								<flat-pickr
									v-model="form.endDate"
									id="endDate"
									class="form-select"
									placeholder="Select end date"
								/>
							</div>
						</div>
						<div class="col">
							<div class="form-group mb-4">
								<input type="text" v-model="form.search" name="search" class="form-control" placeholder="Search">
							</div>
						</div>
						<div class="col space-x-1 mb-4">
							<button type="submit" class="btn btn-alt-primary">
								<i class="fa fa-search me-1"></i>Search
							</button>
							<button
								@click="$inertia.visit(route('admin.transactions.pending'))"
								type="button"
								class="btn btn-alt-secondary"
							>
								<i class="fa fa-retweet me-1"></i>Reset
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>#</th>
								<th>TXNID</th>
								<th>NAME</th>
								<th>DATE</th>
								<th>EMAIL</th>
								<th>COURSE</th>
								<th>AMOUNT</th>
								<th>REFERENCE</th>
							</tr>
						</thead>
						<tbody class="fs-sm">
							<tr
								v-for="(transaction, index) in transactions.data"
								:key="transaction.counter"
							>
								<td>{{ index + transactions.from }}</td>
								<td nowrap="">
									{{ transaction.txnid }}
									<div v-if="transaction.mop=='OVER_THE_COUNTER' || transaction.mop=='BANK_TRANSFER'">
										<button @click="viewUpdate(index)" type="button" class="btn btn-success btn-sm"><i class="fa fa-edit me-1"></i>Edit</button>
										<button v-if="transaction.mop=='BANK_TRANSFER'" @click="viewCancel(index)" type="button" class="btn btn-warning btn-sm ms-1"><i class="fa fa-times me-1"></i>Cancel</button>
									</div>
								</td>
								<td>{{ transaction.fullname }}</td>
								<td>
									{{ transaction.rdate }}
									<div class="clearfix">
										{{ transaction.rtime }}
									</div>
								</td>
								<td>{{ transaction.email }}</td>
								<td>
									<small>{{ transaction.course }}</small>
								</td>
								<td class="text-end">&#8369;{{ transaction.amount }}</td>
								<td>{{ transaction.mop }}</td>
							</tr>
							<tr v-if="transactions.data.length == 0">
								<td colspan="12" class="text-center">NO DATA FOUND</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination :collections="transactions" />
			</div>
		</div>
	</div>



	<modal ref="saveModal" size="modal-md">
		<template #title>
			Update Confirmation
		</template>
		<template #body>
			<div class="mb-4 text-center">
				<span class="badge bg-info fs-3">{{formUpdate.current_rank}}</span>
				<div>{{formUpdate.course}}</div>
			</div>
			<div class="mb-4">
				<label>Name</label>
				<div class="form-control">{{formUpdate.name}}</div>
			</div>
			<div class="mb-4">
				<label>Email</label>
				<div class="form-control">{{formUpdate.username}}</div>
			</div>
			<div class="mb-4">
				<label>Amount</label>
				<div class="form-control">{{formUpdate.amount}}</div>
			</div>
			<div class="mb-4">
				<label>Payment Mode</label>
				<select v-model="formUpdate.pmethod" class="form-select">
					<option value="POS">POS</option>
					<option value="CASH">CASH</option>
					<option value="QRCODE">QR CODE</option>
					<option value="BANK_TRANSFER">BANK TRANSFER</option>
				</select>
			</div>
			<div class="mb-4">
				<label>Ref#</label>
				<input type="text" v-model="formUpdate.refno" name="refno" class="form-control"/>
			</div>
			<div class="mb-4">
				<label>Remarks</label>
				<textarea v-model="formUpdate.remarks" class="form-control" rows="5"></textarea>
			</div>
		</template>
		<template #footer>
			<button @click="confirmUpdate" type="button" class="btn btn-sm btn-success" :disabled="formUpdate.processing">
				<div
					v-if="formUpdate.processing"
					class="spinner-border spinner-border-sm me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				<span v-if="!formUpdate.processing">
					<i class="fa fa-save me-1"></i>
				</span>
				Save
			</button>
			<button type="button" class="btn btn-sm btn-danger" @click="saveModal.toggleModal()" :disabled="formUpdate.processing"><i class="fa fa-times"></i> Cancel</button>
		</template>
	</modal>


	<modal ref="confirmModal" size="modal-md">
		<template #title>
			Cancel Confirmation
		</template>
		<template #body>
			<div class="mb-4 text-center">
				<span class="badge bg-info fs-3">{{formUpdate.current_rank}}</span>
				<div>{{formUpdate.course}}</div>
			</div>
			<div class="mb-4">
				<label>Name</label>
				<div class="form-control">{{formUpdate.name}}</div>
			</div>
			<div class="mb-4">
				<label>Email</label>
				<div class="form-control">{{formUpdate.username}}</div>
			</div>
			<div class="mb-4">
				<label>Amount</label>
				<div class="form-control">{{formUpdate.amount}}</div>
			</div>
			<div class="mb-4">
				<label>Remarks</label>
				<textarea v-model="formUpdate.remarks" class="form-control" rows="5"></textarea>
			</div>
		</template>
		<template #footer>
			<button @click="confirmCancel" type="button" class="btn btn-sm btn-success" :disabled="formUpdate.processing">
				<div
					v-if="formUpdate.processing"
					class="spinner-border spinner-border-sm me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				<span v-if="!formUpdate.processing">
					<i class="fa fa-save me-1"></i>
				</span>
				Yes
			</button>
			<button type="button" class="btn btn-sm btn-danger" @click="confirmModal.toggleModal()" :disabled="formUpdate.processing"><i class="fa fa-times"></i> No</button>
		</template>
	</modal>


</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster';

export default {
	layout: AuthLayout,
	props: {
		transactions: Object,
		filters: Object,
		api_response: Object
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const saveModal = ref(null);
		const confirmModal = ref(null);

		const selected = reactive({});
		

		const form = useForm({
			otc: props.filters.otc,
			bank_transfer: props.filters.bank_transfer,
			search: props.filters.search,
			startDate: props.filters.startDate,
			endDate: props.filters.endDate,
		})

		const formUpdate = useForm({
			txnid 			: "",
			name 			: "",
			username 		: "",
			current_rank 	: "",
			course 			: "",
			amount 			: "",
			pmethod 		: "CASH",
			refno 			: "",
			remarks 		: ""
		})


		const viewUpdate = (_index)=>{
			Object.assign(selected,props.transactions.data[_index]);

			formUpdate.txnid 			= selected.txnid;
			formUpdate.name 			= selected.fullname;
			formUpdate.username 		= selected.username;
			formUpdate.current_rank 	= selected.codetype;
			formUpdate.course 			= selected.course;
			formUpdate.amount 			= selected.amount;

			saveModal.value.toggleModal();
		}

		const viewCancel = (_index)=>{
			Object.assign(selected,props.transactions.data[_index]);

			formUpdate.txnid 			= selected.txnid;
			formUpdate.name 			= selected.fullname;
			formUpdate.username 		= selected.username;
			formUpdate.current_rank 	= selected.codetype;
			formUpdate.course 			= selected.course;
			formUpdate.amount 			= selected.amount;

			confirmModal.value.toggleModal();
		}

		const submit = () => {
			form.get(route('admin.transactions.pending'), {
				preserveState: true,
				preserveScroll: true,
			})
		}

		const confirmUpdate = ()=>{
			formUpdate.put('pending/'+formUpdate.txnid, {
				preserveState: true,
				preserveScroll: true,
				onSuccess:()=>{
					saveModal.value.toggleModal();
				}
			})
		}

		const confirmCancel = ()=>{
			formUpdate.put('pending/cancel/'+formUpdate.txnid, {
				preserveState: true,
				preserveScroll: true,
				onSuccess:()=>{
					confirmModal.value.toggleModal();
				}
			})
		}


		watch(()=>form.otc, (value) => {
			submit()
		})

		watch(()=>form.bank_transfer, (value) => {
			submit()
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{	
				if(value.result=="success")
				{	
					toast.show(value.data, { type: value.result});
				}else
				{
					toast.show(value.data, { type: "error"});
				}
			}
		})

		return {
			saveModal,
			confirmModal,
			form,
			formUpdate,
			selected,
			viewUpdate,
			viewCancel,
			submit,
			confirmUpdate,
			confirmCancel,
		}
	},
}
</script>
